import { cellRenderParseData, cellRenderStatus } from '../../utils/functions';
import { cellRenderPopupTn } from '../PopupActMVP/functionPopupAct';

const columnDataGridTtn = [
  {
    dataField: 'ttnDocumentId',
    caption: 'Номер ТН',
    dataType: 'string',
    cellRender: cellRenderPopupTn,
    cssClass: 'td-button-cell-render',
    allowSearch: true
  },
  {
    dataField: 'ttnDocumentNumId',
    caption: 'id ТН',
    dataType: 'number',
    notVisible: true,
    allowSearch: false
  },
  {
    dataField: 'docStatusDescr',
    caption: 'Статус ТН',
    dataType: 'string',
    cellRender: cellRenderStatus,
    allowSearch: false
  },
  {
    dataField: 'ttnDocumentDate',
    caption: 'Дата ТН',
    dataType: 'date',
    cellRender: cellRenderParseData,
    allowSearch: false
  },
  {
    dataField: 'vehicleId',
    caption: 'Номер ТС/прицепа',
    dataType: 'string',
    notVisible: false,
    allowSearch: false
  },
  {
    dataField: 'driverNameShort',
    caption: 'ФИО водителя',
    dataType: 'string',
    notVisible: false,
    allowSearch: false
  },
  {
    dataField: 'expeditorFlag',
    caption: 'Экспедитор',
    dataType: 'boolean',
    notVisible: true,
    allowSearch: false
  },
  {
    dataField: 'actualShippingDate',
    caption: 'Актуальная дата отгрузки',
    dataType: 'date',
    notVisible: true,
    allowSearch: false
  },
  {
    dataField: 'netWeight',
    caption: 'Вес нетто, т',
    dataType: 'number',
    notVisible: true,
    allowSearch: false
  },
  {
    dataField: 'grossWeight',
    caption: 'Вес брутто, т',
    dataType: 'number',
    notVisible: true,
    allowSearch: false
  },
  {
    dataField: 'weightSeparation',
    caption: 'Вес сепарации, кг',
    dataType: 'number',
    notVisible: true,
    allowSearch: false
  }
];

export default columnDataGridTtn;
